export default __webpack_public_path__ + "static/media/improved-fire-resistance.d1200efb.svg";